import { ArrowUpRight } from "lucide-react"

/**
 * Tombol "Beli di sini" — satu bentuk untuk semua etalase.
 *
 * Menggantikan tombol oranye "Beli di Shopee". Dua alasan:
 *  - Menyebut lapak tujuan di muka memindahkan pertimbangan pembaca ke "nanti
 *    saja, cari dulu di Shopee" — padahal tautannya justru menuju ke sana.
 *  - Oranye Shopee bertabrakan dengan hijau merek sendiri; di halaman yang
 *    penuh kartu, tombol jadi elemen paling berisik dan halaman terasa iklan.
 *
 * Warna primer merek, sudut membulat, dan panah yang bergeser halus saat
 * disentuh: tetap jelas bisa diklik tanpa berteriak.
 */

type Ukuran = "sm" | "md" | "lg"

const UKURAN: Record<Ukuran, string> = {
  sm: "py-2 text-[11px] gap-1",
  md: "py-2.5 text-xs gap-1.5",
  lg: "py-3.5 text-sm gap-2",
}

const IKON: Record<Ukuran, number> = { sm: 12, md: 14, lg: 18 }

export function TombolBeli({
  href,
  label = "Beli di sini",
  ukuran = "md",
  className = "",
}: {
  href: string
  label?: string
  ukuran?: Ukuran
  className?: string
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`group flex w-full items-center justify-center rounded-xl bg-primary font-bold
        text-primary-foreground shadow-sm transition-all hover:shadow-md
        active:scale-[0.98] ${UKURAN[ukuran]} ${className}`}
    >
      {label}
      <ArrowUpRight
        size={IKON[ukuran]}
        className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        aria-hidden
      />
    </a>
  )
}
